<template>
  <div v-if="doc.url" class="asExternalDocument">
    <div
      class="asExternalDocument_link"
      :class="{
        '-icon': icon
      }"
      @click="handlerClick"
    >
      {{ doc.title }}
    </div>

    <as-modal
      v-if="isModal"
      :model-value="isShowModal"
      @update:modelValue="showModal = false"
      type-modal="fullSize"
    >
      <iframe :src="doc.url" class="asExternalDocument_iframe"></iframe>
    </as-modal>
  </div>
  <a
    v-else-if="doc.file"
    :key="doc.id"
    class="asDocuments_doc"
    :class="`-${doc.file.type}`"
    :href="doc.file.url"
    target="_blank"
  >
    {{ doc.title }}
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AsModal from '@web/components/AsModal.vue'

import useExternalDocument, { props } from '@web/composition/useExternalDocument'

import getBaseUrl from '@web/common/getBaseUrl'

export default defineComponent({
  components: {
    AsModal
  },
  props,
  setup (props) {
    return {
      // TODO: передавать явно пропсы
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ...useExternalDocument(props),
      getBaseUrl
    }
  }
})
</script>

<style lang="scss">
  .asExternalDocument {
    &_link {
      cursor: pointer;
      display: flex;
      align-items: center;

      color: #2954FB;
      font-size: 14px;
      line-height: 20px;
      text-decoration: none;
      margin-bottom: 16px;

      &.-icon::before {
        content: '';

        display: inline-block;
        height: 16px;
        width: 14px;
        border-radius: 0;
        background-image: url("~@web/assets/images/icon-document.svg");
        margin-right: 12px;

        background-color: transparent;
      }
    }

    &_iframe {
      width: 100%;
      height: 100%;
    }
  }
</style>
